// 注文内容確認ステップ

<template lang="pug">
.confirm-step

  article.confirm

    ps-medium-heading ご注文者内容の確認

    //- 注文者の情報
    ps-form-item.user(label='ご注文者')
      p
        | {{ userName }} 様
        br
        | ({{ userNameKana }} 様)

      p
        | &#12306;{{ userZipcode }}
        br
        | {{ userAddress1 }}
        br
        | {{ userAddress2 }}
      p TEL: {{ userTel }}

    //- お子様情報
    ps-form-item.child(v-if='!isPublic', label='お子様(参加者)情報')
      ul.new-child-list(v-if='role === "member" && useNewChildrenInfoSystem')
        li(v-for='child in selectedChildren')
          | {{ child.name1 }} {{ child.name2 }} 様
          | ({{ child.attribute }})
      p(v-else)
        | ご関係: {{ childRelation }}
        br
        | {{ childName }} 様
        br
        | ({{ childNameKana }} 様)
        br
        | {{ childAttribute }}

    //- お届け先情報
    ps-form-item.destination(v-if='isIndividual', label='お届け先')
      template(v-if='destType === "same"')
        p ご注文者と同じ
      template(v-else)
        p
          | {{ destinationName }} 様
          br
          | ({{ destinationNameKana }} 様)
        p
          | &#12306;{{ destinationZipcode }}
          br
          | {{ destinationAddress1 }}
          br
          | {{ destinationAddress2 }}
        p TEL: {{ destinationTel }}

    //- 支払い情報
    ps-form-item.payment(label='お支払い方法')
      p {{ paymentMethod }}

  article
  
    ps-medium-heading お届けについて

    p(v-if='!isIndividual')
      | 園・学校 または 写真館 から写真をお渡しします。
    p(v-else)
      | ヤマト運輸のネコポス等にてお客様に直接お送りいたします。

  article.buttons

    ps-agreement.agreement(v-model='agreement')
      | 内容に間違いがないことを確認しました。
      p(slot='content')
        ps-button.commit-button(size='large', color='red', full-width,
          text-centered, :disabled='!agreement || buttonLock', @click='commitOrder', v-my-id='"commit"')
          ps-icon(icon='check')
          | &nbsp;注文を確定する
    p.go-to-prev
      ps-button(@click='goToPrev', :disabled='buttonLock')
        ps-icon(icon='chevron-circle-left')
        | &nbsp;内容修正

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmStep',

  props: {
    // 登録ステップで取得したお子様の情報
    userChildren: null,
    // ボタンのロック状態
    buttonLock: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 利用規約への同意
      agreement: false,
    }
  },

  computed: {
    ...mapGetters({
      role: 'app/role',
      // 販売の情報
      isPublic: 'sale/isPublic',
      useNewChildrenInfoSystem: 'sale/useNewChildrenInfoSystem',
      isIndividual: 'sale/isIndividual',
      // 注文者の情報
      userName: 'order/userName',
      userNameKana: 'order/userNameKana',
      userZipcode: 'order/userZipcode',
      userAddress1: 'order/userAddress1',
      userAddress2: 'order/userAddress2',
      userTel: 'order/userTel',
      // お子様の情報(旧タイプ)
      childRelation: 'order/childRelation',
      childName: 'order/childName',
      childNameKana: 'order/childNameKana',
      childAttribute: 'order/childAttribute',
      selectedNewChildIds: 'order/selectedNewChildIds',
      // お届け先の情報
      // = other なら、他のお届け先に送る
      destType: 'order/destType',
      destinationName: 'order/destinationName',
      destinationNameKana: 'order/destinationNameKana',
      destinationZipcode: 'order/destinationZipcode',
      destinationAddress1: 'order/destinationAddress1',
      destinationAddress2: 'order/destinationAddress2',
      destinationTel: 'order/destinationTel',
      // 支払い方法
      paymentMethod: 'order/paymentMethod',
    }),
    saleId() {
      return this.$route.params.saleId
    },
    // 2020年〜の新しいお子様管理において、選択済みのお子様情報
    selectedChildren() {
      if (!this.userChildren) {
        return []
      }
      return _.filter(this.userChildren, child => {
        return this.selectedNewChildIds.indexOf(child.id) !== -1
      })
    },
  },

  methods: {
    // 注文確定の処理
    commitOrder() {
      this.$emit('commitOrder')
    },

    // 前のステップに戻る
    goToPrev() {
      this.$emit('goToPrev')
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../../../sass/variables.sass'
@import '../../../../../sass/mixins.sass'

.confirm-step
  > article
    margin-bottom: 3rem
    &:last-child
      margin-bottom: 2rem

    &.confirm
      p
        line-height: 1.4
        margin-bottom: 0.5rem
        &:last-child
          margin-bottom: 0

      .new-child-list
        li
          list-style-type: disc
          list-style-position: inside

    &.buttons
      > .agreement
        margin-bottom: 1.5rem
        p
          padding: 0.5rem 1rem 1.5rem
          max-width: 400px
          margin: 0 auto
      > p
        text-align: center
      > .wrapper
        margin: 0 auto
        text-align: center
        max-width: 400px
        .commit-button
          margin-bottom: 1rem
      > .go-to-prev
        margin-top: 3rem
</style>
